var UploadStatusBar = {
    "resetBar": function()
    {
        $("#upload-bar").width("20%");
        $("#upload-message").html("Uploading PDF...");
    },

    "show": function()
    {
        $("#upload-view").show();
    },

    "hide": function()
    {
        $("#upload-view").hide();
    },

    "updateBar": function(percentDone)
    {
        var message;
        message = "Uploading PDF...";

        if (percentDone > 70) {
            message = "Processing PDF...";
        }

        if (percentDone > 80) {
            message = "Optimizing PDF...";
        }

        if (percentDone > 90) {
            message = "Preparing PDF for Edits...";
        }

        $("#upload-bar").width(percentDone+"%");
        $("#upload-message").html(message);
    }
};

module.exports = UploadStatusBar;



// WEBPACK FOOTER //
// ./src-assets/js/upload-status-bar.js